// ABOUTME: Client-side AES encryption service for scratchpad data.
// ABOUTME: WARNING: This provides obfuscation only, not real security — the key is in the JS bundle.
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";

interface CryptoConfig {
  secretKey: string;
}

export const cryptoService = {
  config: {
    secretKey: import.meta.env.VITE_CRYPTO_SECRET_KEY || "",
  } as CryptoConfig,

  encrypt: (data: string): string => {
    if (!cryptoService.config.secretKey) throw new Error("Encryption key not configured");
    try {
      return AES.encrypt(data, cryptoService.config.secretKey).toString();
    } catch (error) {
      console.error("Encryption failed:", error);
      throw new Error("Failed to encrypt data", { cause: error });
    }
  },

  decrypt: (encryptedData: string): string => {
    if (!cryptoService.config.secretKey) throw new Error("Encryption key not configured");
    try {
      const bytes = AES.decrypt(encryptedData, cryptoService.config.secretKey);
      const decryptedData = bytes.toString(Utf8);
      if (!decryptedData) {
        throw new Error("Decryption resulted in empty data");
      }
      return decryptedData;
    } catch (error) {
      console.error("Decryption failed:", error);
      throw new Error("Failed to decrypt data", { cause: error });
    }
  },
};
